<template>
	<widget-card
		colClasses="xs12"
		:heading="widget.text.caption[$i18n.locale]" custom-card-classes="chart-wrapper">
		 <v-select
        	:items="eventGroups"
		  	v-model="eventGroup"
			box
			label="Event"
		 	 v-if="widget.data.groupBy === 'wo_partner_name'"></v-select>
		<pie-chart :values="values" :is-money-value="isMoneyValue" :styles="myStyles"></pie-chart>
	</widget-card>
</template>

<script>
	import Enumerable from 'linq'
	import PieChart from './PieChart.js'
	import { mapGetters } from 'vuex'
	import widgetList from '../../views/admin/dashboards/widget-list.js'

	export default {
		props: {
			widget: {
				type: Object,
				required: true
			}
		},
		components: {
			PieChart
		},
		computed: {
			...mapGetters([
				'season',
				'reportingData'
			]),
			myStyles () {
				if (this.widget.data.groupBy === 'wo_partner_name') {
					return {
						height: `80%`,
						position: 'relative'
					}
				} else {
					return {
						height: `95%`,
						position: 'relative'
					}
				}
			},
			eventGroups: function () {
				if (this.reportingData.length > 0 && this.season) {
					// let result = this.reportingData
					const result = Enumerable.from(this.reportingData)
							.groupBy(`{Label: $.event_group_name, FromDate: $.fromDate}`, null, (key, g) => {
								return {
									event_group_name: key.Label,
									fromDate: key.FromDate,
								}
							}, '$.Label')
							.orderBy('$.fromDate')
							.select('$.event_group_name')
							.toArray()
					this.eventGroup = result[0]
					return result
				} else {
					return []
				}
			},
			values: function () {
				if (this.reportingData.length) {
					if (this.widget.data.sumField) {
						let enu = Enumerable.from(this.reportingData)

						if (this.widget.data.groupBy === 'wo_partner_name') {
							enu = enu.where(item => item.event_group_name === this.eventGroup)
									.groupBy(`$.${this.widget.data.groupBy}`, null, (key, g) => {
										return {
											label: key || 'External',
											value: g.sum(`$.${this.widget.data.sumField.field}`),
											color: g.select(item => item.color).first()
										}
									})
						} else {
							enu = enu.groupBy(`$.${this.widget.data.groupBy}`, null, (key, g) => {
									return {
										label: key,
										value: g.sum(`$.${this.widget.data.sumField.field}`),
										color: g.select(item => item.color).first()
									}
								})
						}

						return enu
							.orderBy('$.value')
							.toArray()
					}
					return []
				} else {
					return []
				}
			},
			value: function () {
					let enumerable = Enumerable.from(this.reportingData)

					// let result = this.reportingData
					Object.keys(this.widget.data.conditions).map(key => {
						enumerable = enumerable.where(item => item[key] === this.widget.data.conditions[key])
					})
					return enumerable
						.select(item => item[this.widget.data.sumField])
						.sum()
			},
			isMoneyValue: function () {
				return this.widget.data.sumField ? this.widget.data.sumField.isMoneyValue : false
			}
		},
		data() {
			return {
				eventGroup: ''
			}
		}
	}
</script>
<style>
.chart-wrapper {
  position: relative;
  height: 95%;
  width: 100%;
}
</style>

